module.exports = __webpack_public_path__ + "static/media/po-Reman_Minor_Pistons_Xparent.2b59f71e.png";